import { Component, Input, OnInit } from '@angular/core';
import { BaseAppMComponent } from '../../base-components/base-app-m.component';
import { GlobalsService } from '../../services/globals.service';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';

import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DQOIReferenceData } from '../../models/DQOIReferenceData';
import { BaseDQOIComponent } from '../../base-components/base-dqoi.component';
import { InventoryService } from '../../services/inventory.service';
import { CRUDActions } from '../../enums/CRUDActions';
import { InventoryTypeBus } from '../../models/InventoryTypeBus';
import { CommonFunctions } from '../../static/common-functions';
import { CPDialogResult } from '../../enums/CPDialogResult';
import { ConfirmOutput } from '../../models/ConfirmOutput';
import { CommonValues } from '../../static/CommonValues';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';

@Component({
    selector: 'part-type-dialog',
    templateUrl: './part-type-dialog.component.html',
    styleUrls: ['./part-type-dialog.component.scss'],
    standalone: false
})
export class PartTypeDialogComponent extends BaseAppMComponent<InventoryTypeBus, InventoryService, null, null> implements OnInit {

    appCode: string = null;
    constructor(
        globals: GlobalsService,
        featureFlagService: FeatureFlagService,
        public svc_data: InventoryService,
        qry_rd: DQOIReferenceDataQuery,

    ) {
        super(globals, featureFlagService, qry_rd);

        this.appCode = "Part Type";
    }

    public editForm: UntypedFormGroup;

    get referenceData(): DQOIReferenceData {
        this.editForm.invalid
        return BaseDQOIComponent._referenceData;
    }

    saving: boolean = false;
    active: boolean = false;
    data: any;
    isTypeSelected: boolean = false;
    isNewType: boolean = false;
    isSaveReady: boolean = false;

    inventoryTypeData: InventoryTypeBus[] = [];
    selectedTypeData: InventoryTypeBus;
    action1: CRUDActions;

    @Input() title: string;
    @Input() message: string;

    public show(id?: any) {
        this.createForm();
        this.active = true;
        this.isTypeSelected = false;
        this.isNewType = false;
        this.isSaveReady = false;

        this.svc_data.getInventoryTypes().subscribe(data => {
            this.inventoryTypeData = data.resultList;
        });
    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'inventoryTypeId': new UntypedFormControl(),
            'inventoryTypeName': new UntypedFormControl(null, Validators.required),
            'isActive': new UntypedFormControl(),
        });
    }

    public inventoryTypeSelected(selectedValue: any): void {
        if (selectedValue) {
            let dataObject: InventoryTypeBus = this.inventoryTypeData.find(x => x.inventoryTypeId === selectedValue.inventoryTypeId);
            this.setTypeFormData(dataObject);
            this.isTypeSelected = true;
            this.isSaveReady = true;
            this.isNewType = true;
        }
        else {
            this.clear();
            this.isTypeSelected = false;
            this.isSaveReady = false;
            this.isNewType = false;
        }
    }

    public setTypeFormData(formData: InventoryTypeBus) {
        if (CommonFunctions.hasValue(formData)) {
            this.editForm.patchValue({
                inventoryTypeId: formData.inventoryTypeId,
                inventoryTypeName: formData.inventoryTypeName,
                isActive: formData.isActive,
            });
        }
        else {
            console.log("No data to map")
        }
    }

    ok() {
        this.trySave();
    }

    new() {
        this.isTypeSelected = true;
        this.isNewType = true;
        this.isSaveReady = true;
        this.editForm.patchValue({
            isActive: true,
        });
    }

    trySave() {
        let inventoryTypeId = this.editForm.value.inventoryTypeId;
        let inventoryTypeName: any = this.editForm.value.inventoryTypeName;
        let isPartActive = this.editForm.get("isActive").value;

        let doesInventoryTypeExist: any = this.inventoryTypeData.find(s => s.inventoryTypeName === inventoryTypeName && inventoryTypeId != s.inventoryTypeId);
        if (doesInventoryTypeExist) {
            this.cnfShow("The inventory type already exists.", CRUDActions.None, null, "Duplicate Inventory Type", "DUP_inventoryTypeName", false);

        }
        else {
            this.save();
        }

    }

    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok && data.code === "EDIT_EXISTING") {
            this.save();
        }
    }

    save() {
        if (this.isSaveReady) {
            let user = this.globals.user;
            let inventoryTypeName: any = this.editForm.value.inventoryTypeName;
            let busObj: InventoryTypeBus = new InventoryTypeBus();

            busObj.setFromForm(this.editForm.value);
            busObj.companyId = this.globals.companyId;
            busObj.setCommon(user.userid, new Date(Date.now()));
            busObj.setBeforeSave();

            if (!busObj.inventoryTypeId) { busObj.inventoryTypeId = CommonValues.Guid_Empty }

            this.svc_data.saveInventoryType(busObj).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.saveSuccess();
                    this.svc_data.getInventoryTypes().subscribe(data => {
                        this.inventoryTypeData = data.resultList;
                    });
                    this.clear();
                    this.isTypeSelected = false;
                    this.isSaveReady = false;
                    this.isNewType = false;
                   // this.hide();
                }
                else {
                    this.saveError(info.message);
                }
            },
                err => { this.CallFailed(err) }
            );
        }
    }

    CallFailed(err) {
        this.saveError(err)
    }

    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action1 = CRUDActions.None;
    }

    cancel() {

        if (this.isNewType) {

        this.clear();
        this.isTypeSelected = false;
        this.isSaveReady = false;
        this.isNewType = false;
        } else
        {
            this.hide();
        }

    }

    close() {
        this.hide();
    }
}
